import { c as _c } from "react/compiler-runtime";
import { usePostHog } from '@posthog/next';
import { useMobilePlayCtaPlacementContext } from '@/context/MobilePlayCtaPlacementContext';
import { useUAContext } from '@/context/UAContext';

/**
 * Resolves the world-detail mobile Play CTA variant and tracking for app and browser sources.
 */
export function useMobilePlayCtaVariant() {
  const $ = _c(14);
  const posthog = usePostHog();
  const {
    hasDismissedConsent,
    playPosition
  } = useMobilePlayCtaPlacementContext();
  const {
    isMobileApp,
    isMobileLandscape
  } = useUAContext();
  const source = isMobileApp ? "mobile_app" : "mobile_browser";
  const t0 = String(hasDismissedConsent);
  let t1;
  if ($[0] !== playPosition || $[1] !== source || $[2] !== t0) {
    t1 = {
      "data-ph-capture-attribute-cta": "world-detail-mobile-play",
      "data-ph-capture-attribute-play-position": playPosition,
      "data-ph-capture-attribute-prior-consent": t0,
      "data-ph-capture-attribute-source": source
    };
    $[0] = playPosition;
    $[1] = source;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const captureAttributes = t1;
  let t2;
  if ($[4] !== hasDismissedConsent || $[5] !== playPosition || $[6] !== posthog || $[7] !== source) {
    t2 = () => {
      posthog.capture("play_button_click", {
        cta: "world-detail-mobile-play",
        "play-position": playPosition,
        "prior-consent": String(hasDismissedConsent),
        source
      });
    };
    $[4] = hasDismissedConsent;
    $[5] = playPosition;
    $[6] = posthog;
    $[7] = source;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const capturePlayClick = t2;
  const t3 = !isMobileLandscape && playPosition === "icon-label";
  const t4 = !isMobileLandscape && playPosition === "icon-only";
  let t5;
  if ($[9] !== captureAttributes || $[10] !== capturePlayClick || $[11] !== t3 || $[12] !== t4) {
    t5 = {
      captureAttributes,
      capturePlayClick,
      isIconLabel: t3,
      isIconOnly: t4
    };
    $[9] = captureAttributes;
    $[10] = capturePlayClick;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}